import { useTranslation } from 'react-i18next';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '../../../ui/Sheet/Sheet';
import { ActivityChip } from './ActivityChip';
import type { ActivityEntry } from './types';

export interface ActivityLogDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  activities: ActivityEntry[];
}

/** Full tool activity log for a turn — includes failed tools hidden from inline chips. */
export const ActivityLogDrawer = ({
  isOpen,
  onClose,
  activities,
}: ActivityLogDrawerProps) => {
  const { t } = useTranslation('m-agent');

  return (
    <Sheet open={isOpen} onOpenChange={open => !open && onClose()}>
      <SheetContent side='bottom' className='max-h-[70vh] overflow-y-auto'>
        <SheetHeader>
          <SheetTitle>{t('activity_log.title', 'Tool activity')}</SheetTitle>
        </SheetHeader>
        <div className='mt-4 flex flex-col gap-2'>
          {activities.length === 0 ? (
            <p className='text-sm text-slate-500'>
              {t('activity_log.empty', 'No tool activity for this turn.')}
            </p>
          ) : (
            activities.map(a => (
              <div key={a.id} className='flex flex-col gap-1 rounded-lg border border-slate-100 px-3 py-2'>
                <ActivityChip activity={a} />
                {a.errorMessage ? (
                  <p className='text-xs text-red-600'>{a.errorMessage}</p>
                ) : null}
              </div>
            ))
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
};
